/**
 * Mobile navigation — inject search into drawer, toggle body class on trigger.
 */

export function initMenu() {
	// Clone the header search block into the mobile drawer so it's accessible
	// without the collapsed icon-only UX. Original is hidden on mobile via CSS.
	const drawerContent = document.querySelector(
		'.wp-block-navigation__responsive-container-content'
	);
	const navSearch = document.querySelector( '.nav-right .nav-search' );

	if ( drawerContent && navSearch ) {
		const clone = navSearch.cloneNode( true );
		clone.classList.remove( 'nav-search' );
		clone.classList.add( 'drawer-search' );
		// Remove IDs to avoid duplicates in the DOM
		clone.querySelectorAll( '[id]' ).forEach( ( el ) => el.removeAttribute( 'id' ) );
		drawerContent.appendChild( clone );
	}

	// Custom data-menu-toggle handler (for any non-WP hamburger buttons).
	document.addEventListener( 'click', ( e ) => {
		const toggle = e.target.closest( '[data-menu-toggle]' );
		if ( ! toggle ) {
			return;
		}

		const isOpen = document.body.classList.toggle( 'menu-open' );
		toggle.setAttribute( 'aria-expanded', String( isOpen ) );
	} );
}
